import { SwitchElement } from './../../models/switchElement';
import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, OnChanges } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    standalone: false
})
export class SwitchComponent implements OnInit, OnDestroy, OnChanges {

  private readonly ngUnsubscribe = new Subject<boolean>();
  switchContainerWidth: number;

  _switchElements: SwitchElement[];

  @Input() defaultSelection: string;
  @Input() preferredWidth: number;
  @Input() hasRoundedCorners = false;

  elements: string[];
  @Input('elements')
  set switchElements(val) {
    this._switchElements = val.map((elem => ({
      isSelected: elem == this.defaultSelection,
      name: elem
    })));
    const maxNumberOfCharacters = Math.max(...(val.map(elem => elem.length)));
    this.switchContainerWidth = 2 * maxNumberOfCharacters * 0.65 + 1;
  }

  @Output() selectionChanged = new EventEmitter<string>();


  constructor() {}

  ngOnChanges(change){
    if (change.defaultSelection !== undefined) {
      if (change.defaultSelection.firstChange === false) {
        this._switchElements.forEach(e=>e.isSelected = e.name===this.defaultSelection);
      }
    }
  }

  ngOnInit() {
    if(this.preferredWidth){
      if(this.switchContainerWidth<this.preferredWidth){
        this.switchContainerWidth = this.preferredWidth;
      }
    }
  }

  public selectElement(element: SwitchElement) {
    this._switchElements.forEach(tab => tab.isSelected = false);
    element.isSelected = true;
    this.selectionChanged.emit(element.name);
  }

  public selectElementByContextProgrammatically(context: string) {
    this._switchElements.forEach(tab => tab.isSelected = false);
    let element = this._switchElements.find(t => t.name === context);
    element.isSelected = true;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
